import {createSelector} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {IBulletinBoardState} from '@app/core/store/state/bulletin-board.state';

const _selectBulletinBoard = (state: IAppState) => state.bulletinBoard;

export const selectIsLoadingBulletinPosts = createSelector(
	_selectBulletinBoard,
	(state: IBulletinBoardState) => state.isLoading,
);

export const selectBulletinPosts = createSelector(
	_selectBulletinBoard,
	(state: IBulletinBoardState) => state.bulletinPosts,
);

export const selectBulletinPost = createSelector(
	_selectBulletinBoard,
	(state: IBulletinBoardState) => state.postToEdit,
);

export const selectBulletinGroups = createSelector(
	_selectBulletinBoard,
	(state: IBulletinBoardState) => state.groups,
);

export const selectBulletinCommentsByPost = createSelector(
	_selectBulletinBoard,
	(state: IBulletinBoardState) => state.comments,
);

export const selectBulletinBoardPagination = createSelector(
	_selectBulletinBoard,
	(state: IBulletinBoardState) => state.pagination,
);

export const selectBulletinBoardCommentsPagination = createSelector(
	_selectBulletinBoard,
	(state: IBulletinBoardState) => state.commentsPagination,
);

export const selectSelectedPostIdForComments = createSelector(
	_selectBulletinBoard,
	(state: IBulletinBoardState) => state.selectedPostIdForComments,
);

export const selectBulletinBoardPostSeenByInfo = createSelector(
	_selectBulletinBoard,
	(state: IBulletinBoardState) => state.postSeenByInfo,
);

export const selectBulletinBoardPostLikedByInfo = createSelector(
	_selectBulletinBoard,
	(state: IBulletinBoardState) => state.postLikedByInfo,
);

export const selectBulletinBoardPostInfoLoading = createSelector(
	_selectBulletinBoard,
	(state: IBulletinBoardState) => state.isLoadingInfo,
);
export const selectBulletinBoardPostLikesPagination = createSelector(
	_selectBulletinBoard,
	(state: IBulletinBoardState) => state.postLikedByInfoPagination,
);
